function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.375 8.27734V1.22266C0.375 0.985677 0.484375 0.821615 0.703125 0.730469C0.940104 0.639323 1.14062 0.675781 1.30469 0.839844L4.83203 4.36719C4.94141 4.47656 4.99609 4.60417 4.99609 4.75C4.99609 4.89583 4.94141 5.02344 4.83203 5.13281L1.30469 8.66016C1.14062 8.82422 0.940104 8.86068 0.703125 8.76953C0.484375 8.67839 0.375 8.51432 0.375 8.27734Z",
  fill: "black"
});

var SvgSortRight = function SvgSortRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSortRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sort-right.8f32da77.svg";
export { ForwardRef as ReactComponent };